import {
  FollowStatus,
  deletePost,
  deletePostVariables,
  PostTypes,
  topPost,
  topPostVariables,
  ActionType,
  aiCollectionTop,
  aiCollectionTopVariables,
  AiCollectionVisibleType,
} from '~/graphqls/types'
import { DELETE_POST, TOP_POST, AI_COLLECTION_TOP } from '~/graphqls/gqls'
import Link from 'next/link'
import { MyImage } from '~/components/ui/MyImage'
import { MyIcon } from '~/components/ui/MyIcon'
import { useStores } from '~/hooks/useStores'
import { MyBtn } from '~/components/ui/MyBtn'
import FollowBtn from '~/components/business/FollowBtn'
import { observer } from 'mobx-react-lite'
import { ArtworkShareModal } from '../../business/ArtworkShareModal'
import { useAtom } from 'jotai'
import { detailSwiperIndexAtom } from './atom'
import { message, Popover, Modal } from 'antd'
import styles from './AiUserInfo.module.css'
import { useState, useRef } from 'react'
import { useRouter } from 'next/router'
import { useMutation } from '@apollo/client'
import { graphQLErrorMessage, to1200Image } from '~/utils'
import { MyAvatar } from '~/components/ui/MyAvatar'
import { useDebounce } from '~/hooks/useDebounce'
interface Action {
  text: React.ReactNode
  action: () => void
  className?: string
  icon?: JSX.Element
}
const followStatusDesc = {
  [FollowStatus.NON]: { text: '关注', type: 'primary' },
  [FollowStatus.HE_ONE_WAY]: { text: '关注', type: 'primary' },
  [FollowStatus.ME_ONE_WAY]: { text: '已关注', type: 'primary' },
  [FollowStatus.TWO_WAY]: { text: '已关注', type: 'primary' },
}

const AiUserInfo = ({
  post,
  followStatus,
  onFollowChange,
  type,
  setPost,
}: {
  post: PostTypes
  followStatus: FollowStatus | null | undefined
  onFollowChange: (status: FollowStatus) => void
  type?: string
  setPost?: (params: any) => void
}) => {
  const isNote = type === 'note'
  const isCollection = type === 'collection'
  const { store } = useStores()
  const router = useRouter()
  const indexurl = (router.query?.indexurl || '') as string
  const isSelf =
    !!post?.user?.uid && post?.user?.uid === store.userinfo?.base?.uid
  const [shareVisible, setShareVisible] = useState(false)
  const [swiperindex] = useAtom(detailSwiperIndexAtom)
  const contentRef = useRef<HTMLDivElement>(null)

  const [popVisible, setPopVisible] = useState(false)
  const handleOpenChange = (newOpen: boolean) => {
    setPopVisible(newOpen)
  }

  const [deletePostAction] = useMutation<deletePost, deletePostVariables>(
    DELETE_POST
  )
  const [topPostAction] = useMutation<topPost, topPostVariables>(TOP_POST)
  const [topCollectionAction] = useMutation<
    aiCollectionTop,
    aiCollectionTopVariables
  >(AI_COLLECTION_TOP)

  const inviteCode = store.userinfo?.inviteCode || ''
  const qrUrl = `${process.env.NEXT_PUBLIC_MOBILE_WUJIE_SITE}/plaza/${post.id}?inviteCode=${inviteCode}`
  const copyUrl = `${process.env.NEXT_PUBLIC_SITE}/plaza/${post.id}?inviteCode=${inviteCode}`

  const delAction = useDebounce(async () => {
    try {
      await deletePostAction({
        variables: {
          id: post?.id,
        },
      })
      if (indexurl) {
        router.replace(decodeURIComponent(indexurl))
      } else {
        router.back()
      }
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '未知错误')
    }
  }, [post, indexurl])

  const onDelete = () => {
    const openedAiCollection =
      post.aiArtworkInfo?.aiCollection?.visible ===
      AiCollectionVisibleType.SQUARE
    Modal.confirm({
      title: '提示',
      maskStyle: {
        backgroundColor: 'rgba(0,0,0,0.8)',
      },
      width: 270,
      className: 'hookModal dark',
      content: (
        <div className="text-neutral-400 text-sm text-center">
          {openedAiCollection
            ? '删除后作品将同步移出公开至广场的合集'
            : '确定删除吗?'}
        </div>
      ),
      okText: '确认',
      onOk: async () => {
        await delAction()
      },
      cancelText: '取消',
      onCancel: close => {
        close()
      },
    })
  }

  // 置顶
  const onSticky = async ({
    id,
    actionType,
  }: {
    id?: number | null
    actionType: ActionType
  }) => {
    try {
      handleOpenChange(false)
      await topPostAction({
        variables: {
          id,
          actionType,
        },
      })
      message.success(
        actionType === ActionType.CONFIRM ? '已成功置顶' : '已取消置顶'
      )
      setPost && setPost((_post: any) => ({ ..._post, top: !_post.top }))
      // 更新post的数据
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '未知错误')
    }
  }
  // 合集置顶
  const onCollectionSticky = async ({
    id,
    top,
  }: {
    id?: number | null
    top: boolean
  }) => {
    try {
      handleOpenChange(false)
      await topCollectionAction({
        variables: {
          input: {
            id,
            top,
          },
        },
      })
      message.success(top ? '已成功置顶' : '已取消置顶')

      setPost &&
        setPost((_post: any) => {
          if (_post.aiCollection) {
            _post.aiCollection.top = !_post.aiCollection.top
          }
          return { ..._post }
        })
      // 更新post的数据
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '未知错误')
    }
  }

  const actions: Action[] =
    isNote || isCollection
      ? []
      : [
          {
            text: '分享',
            icon: (
              <MyIcon icon="sharesquare" className="text-[20px] text-inherit" />
            ),
            action: () => {
              setShareVisible(true)
            },
          },
        ]

  if (isSelf) {
    if (!isCollection) {
      actions.push({
        text: post.top ? '取消置顶' : '置顶',
        action: () => {
          onSticky({
            id: post.id,
            actionType: !post.top ? ActionType.CONFIRM : ActionType.CANCEL,
          })
        },
      })
    }
    // 笔记 没有编辑
    if (isCollection) {
      actions.push({
        text: post.aiCollection?.top ? '取消置顶' : '置顶',
        action: () => {
          onCollectionSticky({
            id: post.aiCollection?.id,
            top: !post.aiCollection?.top,
          })
        },
      })
      actions.push({
        text: '编辑',
        action: () => {
          router.push(`/ai/collection/${post?.aiCollection?.id}`)
        },
      })
    } else if (!isNote) {
      actions.push({
        text: '编辑',
        action: () => {
          router.replace(`/plaza/edit?id=${post?.id}`)
        },
      })
    }
    // 合集没有删除
    if (!isCollection) {
      actions.push({
        text: '删除',
        action: () => {
          onDelete()
        },
      })
    }
  }

  return (
    <div
      className="relative flex justify-between items-center mb-4"
      ref={contentRef}
    >
      {post?.user?.uid ? (
        <Link href={`/user/${post?.user?.uid}`}>
          <div className="flex items-center">
            <MyAvatar
              className="shrink-0"
              image={post?.user?.avatarUrl as string}
              userRole={post?.user?.userRoleInfo}
              size={32}
            ></MyAvatar>
            <span className="text-neutral-800 text-sm max-w-[140px] line-clamp-1 ml-2">
              {post?.user?.nickname}
            </span>
          </div>
        </Link>
      ) : (
        <div></div>
      )}
      <div className="flex items-center flex-shrink-0">
        {!isSelf && !!post?.user?.uid && (
          <div>
            <FollowBtn
              dark
              targetId={post?.user?.uid}
              status={followStatus}
              onChange={status => onFollowChange(status)}
              statusDesc={followStatusDesc}
            ></FollowBtn>
          </div>
        )}
        {actions.length === 1 && (
          <MyBtn
            $dark
            className="!px-2 ml-4"
            onClick={() => {
              actions[0].action()
            }}
          >
            {actions[0].icon || actions[0].text}
          </MyBtn>
        )}
        {actions.length > 1 && (
          <Popover
            placement="bottom"
            overlayClassName={styles.overlayClass}
            open={popVisible}
            onOpenChange={handleOpenChange}
            content={
              <div className="w-[108px] text-center">
                {actions.map((it, index) => (
                  <div
                    className="px-4 py-2 text-neutral-800 text-xs cursor-pointer hover:bg-neutral-300"
                    key={index}
                    onClick={() => {
                      it?.action?.()
                    }}
                  >
                    {it.text}
                  </div>
                ))}
              </div>
            }
            getPopupContainer={() => contentRef.current || document.body}
          >
            <MyBtn $dark className="!px-2 ml-4">
              <MyIcon icon="more" className="text-[20px] relative top-[2px]" />
            </MyBtn>
          </Popover>
        )}
      </div>
      <ArtworkShareModal
        dark={true}
        visible={shareVisible}
        setVisible={setShareVisible}
        options={{
          type: 'plaza',
          author: post?.user?.nickname!,
          id: post?.id!,
          title: post?.title!,
          imgUrl: to1200Image(post?.imageList?.[swiperindex]?.imageUrl!),
          link: qrUrl,
          copyUrl: copyUrl,
        }}
      />
    </div>
  )
}

export default observer(AiUserInfo)
